<template>
  <v-main>
    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="selectRow"
      :selectable="true"
      @update:selected="(v) => (selectedIds = v)"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="newRow">
          Novo Autorizado...
        </v-btn>
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { Technician, Org } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from './technician-columns'
import { matchAnyLike } from 'oderon-commons/src/utils'

export default {
  pageTitle: 'Autorizados',
  components: {
    GenericReport
  },
  data() {
    return {
      reportSpec: {
        title: 'Autorizados',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'showInactive',
            label: 'Mostrar inativos'
          }
        ]
      },

      adapterSpec: fullSpec,

      // checkboxes marcados (para desativar múltiplos)
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length
      return [
        {
          text: 'Desativar...',
          onClick: () => this.confirmDelete(),
          disabled: len < 1
        },
        {
          text: 'Exportar CSV',
          onClick: () => this.$refs.report.checkDownload()
        }
      ]
    }
  },
  methods: {
    async fetchData({ showInactive, keywords }) {
      let allOrgs = await Org.findAll({ mini: true })
      let rows = await Technician.findAll()
      rows = rows.filter((x) => {
        if (x.deletedAt != null && !showInactive) return false
        return matchAnyLike(
          keywords,
          x.name,
          x.cards && x.cards.map((c) => c.serial)
        )
      })

      rows.forEach((r) => {
        if (r.orgIds != null)
          r.orgs = r.orgIds.map((id) => allOrgs.find((o) => o.id == id))

        if (r.orgs != null)
          r.orgLabels = r.orgs.map((x) => (x == null ? '' : x.label)).join(', ')
      })

      return rows
    },

    selectRow({ row, isMiddle }) {
      if (isMiddle) window.open(`/#/setup/technicians/${row.id}`, '_blank')
      else this.$router.push(`/setup/technicians/${row.id}`)
    },

    async newRow() {
      let label = 'Digite o nome do novo autorizado'
      let name = await this.$prompt({ label })
      if (name != null) {
        let row = await this.$loading(async () => {
          return Technician.save({ name })
        })
        this.$refs.report.reload()
        if (row != null) this.selectRow({ row })
      }
    },

    async confirmDelete() {
      let len = this.selectedIds.length
      let message = `Tem certeza que deseja desativar ${len} autorizados?`
      if (len == 1) {
        let row = this.rows.find((x) => x.id == this.selectedIds[0])
        message = `Tem certeza que deseja desativar o autorizado ${row.name}?`
      }

      let res = await this.$confirmDelete({
        message,
        okText: 'Sim, desativar'
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selectedIds) {
            await Technician.delete(id)
          }
          this.selectedIds = []
          await this.fetchData()
          this.$snack('Desativado com sucesso')
        })
      }
    }
  }
}
</script>

<style></style>
